import { RouteRecordRaw } from 'vue-router';

import { RouteKeys } from '~/router/routes.domain';

export const LoginRoute: RouteRecordRaw = {
	name: RouteKeys.LOGIN,
	path: '/login',
	alias: '',
	components: {
		default: () => import('~/_v3/login/ui/pages/LoginPage.vue')
	},
	meta: {
		public: true
	}
};
